import styled from 'styled-components';

export const SummaryContainer = styled.section``;

export const ProductInfo = styled.div`
  background: #fff;
  overflow: auto;
  padding: 0px 12px 0px;

  & .fadeInEffect {
    animation: fade 5s ease forwards;
    @keyframes fade {
      from {
        opacity: 0.4;
      }
      to {
        opacity: 1;
      }
    }
  }
`;
export const Strip = styled.div`
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  width: max-content;
  background-color: #63b0a8;
`;
